import type { Candidate } from '@entities/candidates';
import type { CandidateProposedVacancy } from '@entities/vacancy';
import { CandidateInterview } from '@widgets/candidate/candidate-interview';
import { CandidatePrivateData } from '@features/candidate/candidate-private-data';
import { CandidateStatusBlock } from '@features/candidate/candidate-status-block';
import { Flex } from '@mantine/core';
import { VacancyList } from '@widgets/vacancy';
import { mapCandidateToPrivateDataProps } from '../utils/candidate-info.mapper';
import { useFeatureFlag } from '@packages/feature-flags/react';
import { CandidateRating, CandidateReviews } from '@widgets/candidate';
import { PROPOSED_VACANCIES_PREVIEW_COUNT } from '../constants';

type GeneralTabProps = {
  candidate: Candidate;
  proposedVacancies: CandidateProposedVacancy[];
  proposedVacanciesTotal: number;
  isProposedVacanciesLoading: boolean;
};

export const GeneralTab = ({
  candidate,
  proposedVacancies,
  proposedVacanciesTotal,
  isProposedVacanciesLoading,
}: GeneralTabProps) => {
  const privateDataProps = mapCandidateToPrivateDataProps(candidate);
  const ratingsAndReviewsEnabled = useFeatureFlag('ratingsAndReviews');

  return (
    <Flex
      wrap='wrap'
      gap={24}
      align='flex-start'
      direction={{ base: 'column', md: 'row' }}
    >
      <Flex direction='column' gap={24} flex={1} w='100%' maw={1070}>
        <CandidatePrivateData {...privateDataProps} />
        <CandidateInterview />
      </Flex>

      <Flex direction='column' gap={24}>
        <CandidateStatusBlock
          candidateId={candidate.id}
          status={candidate.status}
        />
        {ratingsAndReviewsEnabled && (
          <>
            <CandidateRating rating={candidate.rating} />
            <CandidateReviews candidateId={candidate.id} />
          </>
        )}
        <VacancyList
          title='Предложенные вакансии'
          vacancies={proposedVacancies.slice(
            0,
            PROPOSED_VACANCIES_PREVIEW_COUNT
          )}
          totalVacancies={proposedVacanciesTotal}
          viewAllHref={`/candidate-list/${candidate.id}/proposed-vacancies`}
          isLoading={isProposedVacanciesLoading}
        />
      </Flex>
    </Flex>
  );
};
